module.exports = __webpack_public_path__ + "static/media/valuation_new1.6ebbdbf4.png";